export const ENTERPRISE_PROGRAM_COLORS = {
  DEFAULT_ICON_COLOR: '#002761',
  DEFAULT_BANNER_COLOR: '#002761',
} as const;
